import { Component } from 'preact'
import '../../utils/replaceWithPolyfill'
import '../../utils/removePolyfill'

import '../../utils/childNodeBeforePolyfill'
import '../../utils/parentNodeAppendPolyfill'
import Phrase, { fetchPhrase } from '../../libs/translationsUtils/phrase'
import GlobalClick from '../interactive/documentClick'

import ButtonControl from '../../preact-components/button-control'
import Button from '../../control-components/ui-components/Button'
import AttachmentsList from './attachmentsList'
import { toEditorFormat, fromEditorFormat } from './contentConverter'
import AttachmentUploader, { FileSizeError, TotalFileSizeError, FileTypeError } from './attachmentUploader'
import ErrorList from './errorList'
import Poll from './Poll'
import classNames from 'classnames'
import AddTopicCardModal from './AddTopicCardModal'

var EmojiSelector
var CKEditor

const requiredPhrases = [
  ['Forum', 'wysiwyg.embed.btn.title'],
  ['Forum', 'wysiwyg.links.btn.title'],
  ['Forum', 'wysiwyg.links.btn.upload'],
  ['Forum', 'wysiwyg.b.btn.title'],
  ['Forum', 'wysiwyg.i.btn.title'],
  ['Forum', 'wysiwyg.u.btn.title'],
  ['Forum', 'wysiwyg.ol.btn.title'],
  ['Forum', 'wysiwyg.ul.btn.title'],
  ['Forum', 'wysiwyg.image.btn.title'],
  ['Forum', 'wysiwyg.quote.btn.title'],
  ['Forum', 'wysiwyg.emoji.btn.title'],
  ['Forum', 'wysiwyg.poll.btn.title'],
  ['Forum', 'wysiwyg.h1.btn.title'],
  ['Forum', 'wysiwyg.h3.btn.title'],
  ['Forum', 'wysiwyg.code.btn.title'],
  ['Forum', 'wysiwyg.spoiler.btn.title'],
  ['Forum', 'wysiwyg.text.color'],
  ['Forum', 'wysiwyg.background.color'],
  ['Common', 'bb.spoiler.hide-content'],
  ['Common', 'bb.spoiler.show-content'],
  ['Forum', 'Cancel'],
  ['Forum', 'wysiwyg.features.links.link_input--URL'],
  ['Common', 'editor.styles'],
  ['Common', 'editor.paragraph'],
  ['Common', 'editor.callout'],
  ['Common', 'editor.link.display.text'],
  ['Common', 'editor.add'],
  ['Common', 'editor.table'],
  ['Common', 'editor.table.rows'],
  ['Common', 'editor.table.columns'],
  ['Common', 'editor.table.headers'],
  ['Common', 'editor.horizontal.line'],
  ['Common', 'editor.text.color'],
  ['Common', 'editor.background.color'],
  ['Common', 'editor.code.language'],
  ['Common', 'editor.image.caption'],
  ['Common', 'editor.toolbar.more'],
  ['Common', 'editor.table.headers.none'],
  ['Common', 'editor.table.headers.first.row'],
  ['Common', 'editor.table.headers.first.column'],
  ['Common', 'editor.table.headers.both'],
  ['Common', 'editor.formatting.styles'],
  ['Forum', 'o_embed.error.error_service_not_supported'],
  ['Forum', 'topic.reply.placeholder.textarea'],
  ['Forum', 'topic.first.reply.placeholder.textarea'],
  ['Forum', 'new.topic.placeholder.textarea'],
  ['Forum', 'topic.editor.poll.question.title'],
  ['Forum', 'topic.editor.poll.answers.title'],
  ['Forum', 'topic.editor.poll.answers.placeholder'],
  ['Control', 'poll.placeholder.question'],
  ['Forum', 'Remove poll'],
  ['Common', 'file.upload.in.progress']
]

function prepareAttachments (attachments) {
  return attachments.map(attachment => {
    if (attachment.type === 'image') {
      return {
        short_url: (attachment.source || '').split('/').pop(),
        short_thumb_url: (attachment.source_thumb || '').split('/').pop(),
        type: attachment.type
      }
    }
    return {
      filename: attachment.filename,
      type: attachment.type,
      source: attachment.source,
      source_thumb: attachment.source_thumb,
      file_uuid: attachment.file_uuid,
      file_size: attachment.file_size,
      file_original_name: attachment.file_original_name
    }
  })
}

const observeMentions = () => {
  // Select the node that will be observed for mutations
  const mentionList = document.querySelector('.cke_autocomplete_panel:last-child')

  document.getElementsByClassName('.cke_autocomplete_panel')

  // Callback function to execute when mutations are observed
  const callback = function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style' && mentionList.classList.contains('cke_autocomplete_opened')) {
        const leftValue = mentionList.style.left && mentionList.style.left.replace('px', '')
        if (leftValue && document.body.clientWidth < 200 + parseInt(leftValue)) {
          mentionList.style.left = `${document.body.clientWidth - 200}px`
        }
      }
    }
  }

  // Create an observer instance linked to the callback function
  const observer = new window.MutationObserver(callback)

  // Start observing the target node for configured mutations
  observer.observe(mentionList, { attributes: true })
}

function cleanWhiteSpace (content) {
  return content.replace(/&nbsp;/g, '').split('\n').filter(l => l.trim()).join(',').trim()
}

function compareHtml (a, b) {
  return cleanWhiteSpace(a) === cleanWhiteSpace(b)
}

class Editor extends Component {
  constructor (props) {
    super(props)
    if (props.CKEditor) CKEditor = props.CKEditor
    this.state = {
      attachments: [],
      attachmentErrors: [],
      editorErrors: [],
      attachmentToProcess: 0,
      imageToProcess: 0,
      editor: null,
      enablePoll: props.poll != null,
      poll: props.poll != null ? props.poll : {
        question: '',
        options: []
      },
      showTopicCardModal: false
    }

    this.initialData = props.data
    this.editorContent = props.data
    this.initialEditorContent = toEditorFormat(props.data)
    this.submitContent = this.submitContent.bind(this)
    this.setNewEditorInstance = this.setNewEditorInstance.bind(this)
    this.togglePoll = this.togglePoll.bind(this)
    this.editPoll = this.editPoll.bind(this)

    this.attachmentUploader = new AttachmentUploader()
  }

  getEditorContent () {
    if (this.editorContent === undefined) {
      return this.initialData
    }
    return this.editorContent
  }

  componentWillReceiveProps ({ attachments }) {
    attachments = attachments || []
    if (this.state.attachments.length) return
    this.setState({
      attachments: attachments.map(attachment => ({
        url: attachment.short_url || attachment.source,
        filename: attachment.file_original_name,
        ...attachment
      }))
    })
  }

  preloadPhrases (cb) {
    const noop = () => {}
    requiredPhrases.forEach(([m, p], idx) => {
      if (idx === requiredPhrases.length - 1) return fetchPhrase(m, p, noop, cb)
      fetchPhrase(m, p, noop)
    })
  }

  componentDidMount () {
    this.preloadPhrases(() => {
      if (CKEditor) return this.setState({ loaded: true })

      require.ensure(['../../libs/ckeditor/ckeditor.js', '../../libs/emoji/selector'], (require) => {
        CKEditor = require('../../libs/ckeditor/ckeditor.js').default
        EmojiSelector = require('../../libs/emoji/selector').default
        this.setState({ loaded: true })
      }, 'ckeditor')
    })
  }

  attachmentError (filename, errorPhrase) {
    this.setState({
      attachmentToProcess: this.state.attachmentToProcess - 1,
      attachmentErrors: this.state.attachmentErrors.concat({
        filename, errorPhrase
      })
    })
  }

  async uploadFile (file) {
    let attachment
    let uploadData

    try {
      attachment = this.attachmentUploader.prepareFile(file)
    } catch (err) {
      if (err instanceof FileSizeError) {
        this.attachmentError(file.name, 'js.uploader.error_file_size')
      } else if (err instanceof TotalFileSizeError) {
        this.attachmentError(file.name, 'js.attachments.error_total_file_size_per_post')
      }
      return
    }

    this.updateAttachments(
      this.state.attachments.concat(
        Object.assign({ url: '', filename: file.name }, attachment)
      )
    )

    try {
      uploadData = await this.attachmentUploader.waitForUpload(attachment)
    } catch (err) {
      this.updateAttachments(
        this.state.attachments.filter(
          ({ attachmentId }) => attachment.attachmentId !== attachmentId)
      )
      if (err instanceof FileTypeError) {
        this.attachmentError(file.name, 'js.uploader.error_file_type')
        return
      }
      this.attachmentError(file.name, 'js.uploader.error_on_upload')
      return
    }

    this.setState({ attachmentToProcess: this.state.attachmentToProcess - 1 })

    this.updateAttachments(
      this.state.attachments.map(a => {
        if (a.attachmentId !== attachment.attachmentId) return a
        return Object.assign(
          a,
          {
            url: uploadData.source || uploadData.download_url,
            source: uploadData.source || uploadData.download_url,
            source_thumb: uploadData.source_thumb || uploadData.download_url,
            file_uuid: uploadData.uuid
          }
        )
      })
    )
  }

  async uploadAttachments (files) {
    this.setState({ attachmentToProcess: files.length })

    for (let i = 0; i < files.length; i++) {
      this.uploadFile(files[i])
    }
  }

  updateAttachments (attachments) {
    this.setState({ attachments })

    if (!this.props.onChange) return
    this.props.onChange(this.getEditorContent(), prepareAttachments(attachments), (!!this.state.imageToProcess || !!this.state.attachmentToProcess))
  }

  deleteAttachment (index) {
    this.updateAttachments(
      this.state.attachments.filter((_, idx) => idx !== index)
    )
  }

  submitContent (content, attachments, onSubmit) {
    if (this.props.isGuest) {
      const event = new window.CustomEvent('GuestUserAction')
      return window.dispatchEvent(event)
    }

    onSubmit(content, prepareAttachments(attachments), (!!this.state.imageToProcess || !!this.state.attachmentToProcess))
  }

  setNewEditorInstance (instance) {
    this.setState({ editor: instance }, () => {
      this.state.editor.on('filesToProcessCountChange', (evt) => {
        this.setState({ imageToProcess: evt.data.count })
      })

      this.state.editor.on('pollButtonClicked', () => {
        this.togglePoll()
      })

      if (!this.props.disableMentions) {
        observeMentions()
      }
    })
  }

  togglePoll () {
    this.setState({ enablePoll: !this.state.enablePoll, poll: { question: '', options: [] } })
  }

  editPoll (newValue) {
    const newPoll = { ...this.state.poll, ...newValue }
    this.setState({ poll: newPoll }, this.props.onPollUpdate(newPoll))
  }

  render ({
    onChange = () => {},
    onCancel,
    onSubmit,
    cancelPhrase,
    btnText,
    btnPhrase,
    input,
    isControl,
    autoFocus,
    errors,
    isLoading,
    cssLink,
    disableFileAttachments,
    disableMentions,
    placeholder,
    onPollUpdate,
    canHavePoll,
    classes,
    error,
    poll,
    profile
  }, {
    editorErrors
  }) {
    const submitButtonText = btnText || <Phrase p={btnPhrase || 'Send'} />
    const additionalClasses = classes || []
    const hasErrors = Array.isArray(errors) && errors.length > 0
    return (
      <div className='html-editor__wrapper'>
        <ErrorList errors={errors} />
        <div class={classNames({ 'validation-error': error }, 'html-editor', ...additionalClasses, isControl && 'html-editor--control')}>
          <ErrorList errors={
            editorErrors.map(({ category, phrase }) => ({ errorMessage: <Phrase m={category} p={phrase} count={{
              allowed_files_size: '5MB'
            }} /> }))
          } />
          {CKEditor
            ? <CKEditor
              disableFileAttachments={disableFileAttachments}
              disableMentions={disableMentions}
              canHavePoll={canHavePoll}
              isControl={isControl}
              autoFocus={autoFocus}
              onInstanceReady={instance => this.setNewEditorInstance(instance)}
              data={hasErrors ? null : this.initialEditorContent}
              onFileAttachment={evt => this.uploadAttachments(evt.data.files)}
              isGuest={this.props.isGuest}
              placeholder={placeholder}
              cssLink={cssLink}
              profile={profile}
              showNotification={(category, phrase) => {
                this.setState({
                  editorErrors: this.state.editorErrors.concat({ category, phrase })
                })
              }}
              onEmojiSelect={evt => {
                if (this.state.emojiCallback) {
                  return this.setState({
                    emojiCallback: null
                  })
                }
                this.setState({
                  emojiCallback: evt.data.onSelect
                })
              }}
              onTopicCardClicked={evt => {
                const { data } = evt
                this.setState({ showTopicCardModal: true, onAddTopic: data.onAdd })
              }}
              onFocus={() => {
                if (this.state.emojiCallback) this.setState({ emojiCallback: null })
              }}
              onChange={content => {
                content = content.replace(/<oembed(.*)\/>/g, '<oembed$1></oembed>')
                if (this.editorContent && compareHtml(content, this.editorContent)) return
                content = fromEditorFormat(content)
                content = content.replace(/\n/g, '')
                if (this.editorContent !== undefined) {
                  onChange(content, prepareAttachments(this.state.attachments), (!!this.state.imageToProcess || !!this.state.attachmentToProcess))
                }
                this.editorContent = content
                if (!input) return
                document.querySelector(input).value = content
              }}
            />
            : null}

          {/* This empty div is needed to capture a click outside of emoji box (on editable area) and close it */}
          {this.state.emojiCallback && EmojiSelector &&
            <div class='emoji-selector-positioner-background' />}

          {
            this.state.emojiCallback && EmojiSelector
              ? <GlobalClick onGlobalClick={() => {
                this.setState({ emojiCallback: null })
              }} class='emoji-selector-positioner'>
                <EmojiSelector onSelect={(unicode, shortname) => {
                  const emojiCallback = this.state.emojiCallback
                  this.setState({ emojiCallback: null })
                  emojiCallback(unicode, shortname)
                }} />
              </GlobalClick>
              : null
          }

          {
            this.state.showTopicCardModal && <AddTopicCardModal
              isOpen={this.state.showTopicCardModal}
              onAdd={(topic) => {
                this.setState({ showTopicCardModal: false })
                this.state.onAddTopic(topic)
              }}
              onClose={() => this.setState({ showTopicCardModal: false })}
            />
          }
        </div>

        {
          this.state.enablePoll ? (
            <Poll
              {...this.state.poll}
              onDelete={this.togglePoll}
              onChange={(newValue) => this.editPoll(newValue)}
            />
          ) : null
        }

        <AttachmentsList
          attachments={this.state.attachments}
          errors={this.state.attachmentErrors}
          onDelete={idx => this.deleteAttachment(idx)}
          onDismissError={() => this.setState({ attachmentErrors: [] })}
        />

        <div class='html-editor__buttons'>
          {onSubmit && (isControl
            ? <ButtonControl
              disabled={isLoading}
              variant={onCancel ? 'success' : 'primary'}
              onClick={() => this.submitContent(this.getEditorContent(), this.state.attachments, onSubmit)}
              isLoading={isLoading}
              title={onCancel ? 'Save changes' : submitButtonText}
            />
            : <Button
              primary
              loading={isLoading}
              disabled={isLoading}
              onClick={() => this.submitContent(this.getEditorContent(), this.state.attachments, onSubmit)}
            >
              {submitButtonText}
            </Button>)}

          {onCancel && (isControl
            ? <ButtonControl
              variant='secondary'
              onClick={() => onCancel()}
              title={<Phrase p={cancelPhrase || 'Cancel'} />}
            />
            : <Button
              secondary
              link
              onClick={() => onCancel()}
            >
              <Phrase p={cancelPhrase || 'Cancel'} />
            </Button>)}
        </div>
      </div>
    )
  }
}

export default Editor
